"use client"
/* */
import { jsx } from 'react/jsx-runtime';
import 'react';
import { OverlayController } from '../../lib/controller/overlay/OverlayController.mjs';
import '../../lib/controller/overlay/context.mjs';
import '../../lib/propsContext/propsContext.mjs';
import '../../lib/viewComponentContext/viewComponentContext.mjs';
import { PropsContextProvider } from '../../lib/propsContext/PropsContextProvider.mjs';
import { OverlayContextProvider } from '../../lib/controller/overlay/OverlayContextProvider.mjs';

const OverlayTrigger = (props) => {
  const {
    overlayType,
    isDefaultOpen = false,
    component: AriaOverlayTrigger,
    children,
    controller: controllerFromProps
  } = props;
  const newOverlayController = OverlayController.useNew({ isDefaultOpen });
  const overlayController = controllerFromProps ?? newOverlayController;
  const isOpen = overlayController.useIsOpen();
  const propsContext = {
    Button: {
      onPress: overlayController.open
    }
  };
  return /* @__PURE__ */ jsx(OverlayContextProvider, { type: overlayType, controller: overlayController, children: /* @__PURE__ */ jsx(PropsContextProvider, { props: propsContext, mergeInParentContext: true, children: /* @__PURE__ */ jsx(AriaOverlayTrigger, { isOpen, children }) }) });
};

export { OverlayTrigger, OverlayTrigger as default };
//# sourceMappingURL=OverlayTrigger.mjs.map
